<template>
  <svg
    v-if="name === 'apple'"
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
  >
    <g fill-rule="nonzero">
      <path
        d="M46.173 19.967C49.927-1.838 19.797-.233 14.538.21c-.429.035-.648.4-.483.8 2.004 4.825 14.168 31.66 32.118 18.957zm13.18 1.636c1.269-.891 1.35-1.614.047-2.453l-2.657-1.71c-.94-.607-1.685-.606-2.532.129-5.094 4.42-7.336 9.18-8.211 15.24 1.597.682 3.55.79 5.265.328 1.298-4.283 3.64-8.412 8.088-11.534z"
      />
      <path
        d="M88.588 67.75c9.65-27.532-13.697-45.537-35.453-32.322-1.84 1.118-4.601 1.118-6.441 0-21.757-13.215-45.105 4.79-35.454 32.321 5.302 15.123 17.06 39.95 37.295 29.995.772-.38 1.986-.38 2.758 0 20.235 9.955 31.991-14.872 37.295-29.995z"
      />
    </g>
  </svg>
  <svg
    v-else-if="name === 'book'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      d="M6 4H5a1 1 0 1 1 0-2h11V1a1 1 0 0 0-1-1H4a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V5a1 1 0 0 0-1-1h-7v8l-2-2-2 2V4z"
    />
  </svg>
  <svg
    v-else-if="name === 'cheveron-down'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
    />
  </svg>
  <svg
    v-else-if="name === 'cheveron-right'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <polygon
      points="12.95 10.707 13.657 10 8 4.343 6.586 5.757 10.828 10 6.586 14.243 8 15.657 12.95 10.707"
    />
  </svg>
  <svg
    v-else-if="name === 'dashboard'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm-5.6-4.29a9.95 9.95 0 0 1 11.2 0 8 8 0 1 0-11.2 0zm6.12-7.64l3.02-3.02 1.41 1.41-3.02 3.02a2 2 0 1 1-1.41-1.41z"
    />
  </svg>
  <svg
    v-else-if="name === 'location'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      d="M10 20S3 10.87 3 7a7 7 0 1 1 14 0c0 3.87-7 13-7 13zm0-11a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
    />
  </svg>
  <svg
    v-else-if="name === 'office'"
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
  >
    <path
      fill-rule="evenodd"
      d="M7 0h86v100H57.108V88.418H42.892V100H7V0zm9 64h11v15H16V64zm57 0h11v15H73V64zm-19 0h11v15H54V64zm-19 0h11v15H35V64zM16 37h11v15H16V37zm57 0h11v15H73V37zm-19 0h11v15H54V37zm-19 0h11v15H35V37zM16 11h11v15H16V11zm57 0h11v15H73V11zm-19 0h11v15H54V11zm-19 0h11v15H35V11z"
    />
  </svg>
  <svg
    v-else-if="name === 'printer'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      d="M4 16H0V6h20v10h-4v4H4v-4zm2-4v6h8v-6H6zM4 0h12v5H4V0zM2 8v2h2V8H2zm4 0v2h2V8H6z"
    />
  </svg>
  <svg
    v-else-if="name === 'shopping-cart'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      d="M4 2h16l-3 9H4a1 1 0 1 0 0 2h13v2H4a3 3 0 0 1 0-6h.33L3 5 2 2H0V0h3a1 1 0 0 1 1 1v1zm1 18a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm10 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
    />
  </svg>
  <svg
    v-else-if="name === 'store-front'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      d="M18 9.87V20H2V9.87a4.25 4.25 0 0 0 3-.38V14h10V9.5a4.26 4.26 0 0 0 3 .37zM3 0h4l-.67 6.03A3.43 3.43 0 0 1 3 9C1.34 9 .42 7.73.95 6.15L3 0zm5 0h4l.7 6.3c.17 1.5-.91 2.7-2.42 2.7h-.56A2.38 2.38 0 0 1 7.3 6.3L8 0zm5 0h4l2.05 6.15C19.58 7.73 18.65 9 17 9a3.42 3.42 0 0 1-3.33-2.97L13 0z"
    />
  </svg>
  <svg
    v-else-if="name === 'trash'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z"
    />
  </svg>
  <svg
    v-else-if="name === 'users'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      d="M7 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0 1c2.15 0 4.2.4 6.1 1.09L12 16h-1.25L10 20H4l-.75-4H2L.9 10.09A17.93 17.93 0 0 1 7 9zm8.31.17c1.32.18 2.59.48 3.8.92L18 16h-1.25L16 20h-3.96l.37-2h1.25l1.65-8.83zM13 0a4 4 0 1 1-1.33 7.76 5.96 5.96 0 0 0 0-7.52C12.1.1 12.53 0 13 0z"
    />
  </svg>
  <svg
    v-else-if="name === 'road_list'"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    id="Capa_2"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="190.559px"
    height="190.559px"
    viewBox="0 0 190.559 190.559"
    style="enable-background: new 0 0 190.559 190.559"
    xml:space="preserve"
  >
    <g>
      <path
        d="M190.385,165.073c-16.088-34.842-26.698-89.557-2.825-123.497c2.988-1.369,3.69-6.068-0.344-7.204
		c-18.26-5.145-33.919-16.581-52.121-22.169c-11.595-3.56-24.218,9.56-32.665,15.227c-9.473,6.354-18.491,12.111-29.054,16.541
		c-4.626,1.939-24.069-7.783-28.511-9.332c-10.986-3.833-27.379-13.524-39.47-12.655c-2.161-1.865-6.262-0.275-5.232,3.113
		c7.392,24.338,18.603,43.657,18.176,70.188c-0.231,14.373-4.164,28.621-8.06,42.356c-1.908,6.727-5.507,11.174-6.285,18.13
		c-0.07,0.624,0.108,1.102,0.42,1.443c-0.448,0.938-0.313,2.22,0.721,2.701c16.562,7.719,34.817,12.217,52.309,17.375
		c12.561,3.704,20.795,1.23,30.908-7.43c5.266-4.51,10.244-9.26,15.151-14.155c7.58-7.562,17.967,0.049,25.937,2.424
		c18.446,5.499,38.804,5.639,56.797,11.449c2.406,0.776,3.881-0.945,4.014-2.853C190.567,166.309,190.686,165.723,190.385,165.073z
		 M103.845,146.368c-17.165,6.099-20.533,29.476-44.328,23.406c-17.07-4.353-33.868-10.842-51.345-13.314
		c0.018-0.042,0.052-0.07,0.067-0.115c2.877-8.292,7.715-15.654,10.657-23.98c4.167-11.794,5.236-24.687,5.798-37.08
		C25.829,70.26,16.038,49.478,7.683,26.92c13.816,5.415,27.473,11.369,41.428,16.617c10.068,3.786,18.892,10.7,29.598,6.508
		c14.571-5.705,27.457-15.067,40.057-24.224c17.344-12.607,42.444,9.151,61.68,15.009c-21.92,33.608-16.582,87.868,4.2,121.077
		c-14.753-5.018-31.767-5.747-46.853-9.723C126.608,149.239,115.328,142.29,103.845,146.368z"
      />
      <path
        d="M160.028,126.496c-1.303-2.197-4.076-3.53-6.627-2.95c-1.122-1.428-2.35-2.624-3.953-3.898
		c-6.686-5.309-8.597-9.568-5.822-17.62c1.478-4.287,5.564-12.086,3.501-16.756c-3.743-8.477-16.458-10.316-26.56-10.956
		c0-0.026,0.009-0.049,0.009-0.075c0-3.737-3.118-6.855-6.855-6.855c-3.858,0-6.485,2.909-6.828,6.584
		c-0.124,1.329,0.254,2.618,0.933,3.734c-4.257,6.635-2.629,15.873-8.483,21.485c-5.515,5.287-14.879,6.753-22.337,9.552
		c-0.703-0.359-1.467-0.615-2.275-0.722c-0.328-2.267-1.092-4.434-1.325-6.785c-0.33-3.324-0.181-6.716-0.236-10.053
		c-0.08-4.852-0.441-11.203-4.398-14.632c-3.206-2.778-8.415-3.66-12.415-4.465c-1.455-0.293-4.178-1.147-6.733-1.559
		c1.711-3.106,0.107-7.372-2.809-9.079c-4.161-2.437-8.797-0.013-10.328,4.201c-0.022,0.062-0.045,0.123-0.067,0.185
		c-1.061,2.922,0.672,6.417,3.218,7.909c1.795,1.051,3.676,1.174,5.384,0.639c1.401,1.075,3.664,1.47,5.119,1.917
		c4.599,1.412,9.565,2.477,13.816,4.774c4.243,2.292,2.698,14.188,2.83,18.196c0.12,3.625,0.354,7.593,2.377,10.507
		c-1.436,1.296-2.365,3.146-2.365,5.196c0,3.839,3.204,7.043,7.043,7.043s7.043-3.204,7.043-7.043c0-1.032-0.254-2.002-0.668-2.888
		c7.934-1.849,16.107-3.178,22.815-8.11c7.061-5.193,6.802-15.22,9.255-23.062c2.02,0.429,4.018-0.121,5.552-1.28
		c4.694,1.075,9.438,1.931,14.081,3.246c3.622,1.026,6.5,2.816,9.539,4.915c0.547,0.378-2.326,8.962-2.585,9.771
		c-2.06,6.45-4.104,11.576-1.603,18.185c1.775,4.69,7.273,7.73,11.269,11.094c-1.593,2.487-1.683,5.848,0.831,8.361
		c4.311,4.312,11.576,1.073,11.716-4.853C161.118,128.992,160.716,127.653,160.028,126.496z"
      />
    </g>
  </svg>
  <svg
    v-else-if="name === 'auto_home'"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="194.889px"
    height="194.889px"
    viewBox="0 0 194.889 194.889"
    style="enable-background: new 0 0 194.889 194.889"
    xml:space="preserve"
  >
    <g>
      <path
        d="M190.85,81.476c0.741-4.424,1.228-9.58-1.156-13.65c-2.197-3.75-9.565-5.858-12.817-8.163
		c-9.337-6.616-18.693-13.2-28.126-19.679c-18.248-12.532-36.434-23.933-53.089-38.621c-0.401-0.354-0.818-0.514-1.226-0.586
		c-1.011-0.798-2.368-1.114-3.623-0.303C74.792,10.833,59.43,22.345,44.495,34.208C32.633,43.629,12.809,55.777,6.181,69.83
		c-0.302,0.641-0.347,1.238-0.295,1.801c-0.563,0.501-0.915,1.203-0.798,2.115c2.502,19.413-0.948,40.349-1.516,59.887
		c-0.535,18.383,0.631,36.529,0.637,54.832c0,0.831,0.72,1.428,1.466,1.539c0.416,0.437,0.986,0.728,1.696,0.724
		c9.124-0.048,19.733,2.541,28.475-0.011c0.909-0.265,1.387-1.161,1.372-2.014c0.592-0.422,0.759-1.27,0.181-1.916
		c-14.31-16.014-4.195-36.656-4.187-55.876c0.001-1.449-0.996-2.221-2.103-2.391c-0.226-0.225-0.498-0.401-0.832-0.416
		c-2.066-0.081-4.189-0.148-5.661-1.758c-1.298-1.419-1.382-3.983-1.288-5.771c0.106-2,0.908-3.945,2.417-5.269
		c1.856-1.627,4.475,0.646,6.296,0.943c1.45,0.236,3.005-0.972,2.71-2.409c0.3,0.186,0.626,0.34,1.02,0.41
		c0.741,0.131,1.294-0.195,1.566-0.89c2.191-5.585,3.492-11.992,5.249-17.941c4.619-15.636,15.146-19.592,30.813-20.93
		c16.873-1.441,33.928-2.03,50.744,0.253c21.625,2.936,26.153,18.096,28.376,37.113c0.33,2.824,3.363,3.784,5.244,2.82
		c0.886-0.222,1.766-0.518,2.67-0.566c3.688-0.194,6.858,1.41,8.843,4.58c1.331,2.127,0.89,4.809-0.386,6.813
		c-1.637,2.575-4.76,0.704-7.024,1.573c-1.367,0.524-2.291,2.078-1.413,3.473c0.139,0.221,0.33,0.369,0.493,0.558
		c0.236,18.116,5.541,42.466-4.641,58.511c-1.318,2.079,0.429,4.591,2.688,4.684c7.922,0.329,15.868-1.83,23.629,0.432
		c1.571,0.458,2.754-0.149,3.412-1.149c1.989-0.341,3.748-2.055,3.019-4.56c-6.381-21.939-0.357-49.907-0.275-72.501
		C188.824,104.679,188.889,93.184,190.85,81.476z M164.136,187.86c3.023-7.357,3.489-15.53,3.681-23.503
		c0.242-10.143,1.365-21.802-2.688-31.355c2.56,0.131,5.381-0.892,7.105-2.468c3.423-3.133,4.353-7.812,3.431-12.229
		c-1.029-4.933-5.884-8.966-10.671-9.867c-1.584-0.298-3.886-0.229-6.009,0.324c-1.399-14.589-5.082-28.76-18.683-36.488
		c-19.087-10.845-49.939-5.329-70.615-3.478c-14.073,1.26-25.842,5.398-30.871,19.273c-0.991,2.735-7.247,17.853-5.429,23.808
		c-2.578-2.343-6.908-2.64-9.958-1.28c-3.428,1.527-5.013,5.716-5.435,9.167c-0.45,3.687,0.396,7.48,2.953,10.256
		c1.929,2.095,4.647,2.603,7.12,1.889c-0.58,9.756-8.765,43.2,0.095,53.821c-6.561-0.855-13.465-1.137-19.802-0.17
		c0.752-3.39,0.593-6.832,0.455-10.517c-0.445-11.911,0.323-23.829,0.653-35.739c0.586-21.093,5.261-44.95,1.644-65.812
		c0.163-0.164,0.341-0.282,0.486-0.494c9.013-13.187,25.556-23.922,37.884-33.801C63.704,27.796,78.986,17.896,93.413,6.805
		c6.096,11.15,18.782,18.71,28.949,25.511c18.271,12.222,36.476,24.443,54.434,37.132c9.491,6.706,6.154,12.43,4.915,22.187
		c-1.524,12-0.299,24.77-0.646,36.869c-0.531,18.499-4.333,40.519-0.148,58.99C175.432,186.46,169.773,187.404,164.136,187.86z"
      />
      <path
        d="M140.749,187.269c-11.123-9.507,2.248-22.979-16.501-23.014c-9.118-0.018-18.423,2.225-27.581,2.62
		c-12.151,0.523-23.918,1.08-35.666,4.384c-1.655,0.465-2.297,2.016-2.041,3.594c-2.73,3.794-5.46,7.588-8.19,11.382
		c-1.899,0.67-1.748,4.052,0.508,3.75c0.115-0.015,0.237-0.037,0.354-0.054c0.068,0.046,0.108,0.113,0.194,0.145
		c11.264,4.061,25.097,1.543,36.923,1.368c16.686-0.245,33.066,0.967,49.637,2.767c1.923,0.209,2.952-1.518,2.912-3.171
		C141.949,189.826,141.988,188.328,140.749,187.269z M94.346,185.526c-10.1,0.048-22.015-1.017-32.684,0.497
		c0.927-0.901,1.68-2.004,2.156-3.376c4.516-13.009,26.985-8.634,38.76-8.984c7.843-0.234,27.126-6.689,26.237,5.207
		c-0.236,3.162,0.645,5.834,2.177,8.124C118.859,185.453,106.592,185.47,94.346,185.526z"
      />
      <path
        d="M135.061,89.175c-15.609-11.512-44.184-9.123-62.481-7.761c-20.54,1.529-25.362,19.551-26.706,37.442
		c-0.038,0.511,0.072,0.921,0.244,1.279c0.039,0.852,0.606,1.665,1.661,1.615c30.555-1.448,61.278,4.024,91.679-1.292
		C155.989,117.565,142.715,94.819,135.061,89.175z M129.669,114.755c-8.912,1.017-18.014,1.443-26.972,1.84
		c-17.221,0.762-34.382-2.802-51.311,0.773c0.768-7.771,2.641-14.92,6.404-21.871c4.93-9.106,18.689-8.153,27.137-8.095
		c13.954,0.096,31.868-1.3,44.296,5.678c3.243,2.218,5.776,5.076,7.6,8.572C142.611,110.903,138.991,113.69,129.669,114.755z"
      />
      <path
        d="M64.366,143.928c-7.418-7.818-29.06-12.929-30.974,0.069c-1.173,7.968,5.515,11.579,12.463,11.315
		c5.866-0.222,16.334-2.405,20.476-7.014C67.942,146.507,66.611,143.852,64.366,143.928z M38.95,145.688
		c-0.477-6.347,12.655-3.16,20.132,0.039C51.646,148.788,39.561,153.821,38.95,145.688z"
      />
      <path
        d="M127.105,146.264c-0.168,0.737,0.086,1.646,0.814,2.004c0.257,0.126,0.456,0.196,0.743,0.227
		c0.002,0,0.005,0.001,0.005,0.001c0.66,5.392,11.482,5.397,15.206,5.109c5.627-0.435,12.508-3.257,12.495-9.816
		C156.34,127.696,129.63,135.162,127.105,146.264z M150.922,144.992c-1.431,3.221-7.864,3.093-10.678,3.025
		c-2.616-0.062-5.733-1.752-8.42-1.995c2.648-2.699,6.189-4.489,9.71-5.719c2.224-0.777,4.559-1.11,6.844-0.451
		C150.131,140.358,151.691,143.261,150.922,144.992z"
      />
    </g>
  </svg>
  <svg
    v-else-if="name === 'maintenance'"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="192.974px"
    height="192.973px"
    viewBox="0 0 192.974 192.973"
    style="enable-background: new 0 0 192.974 192.973"
    xml:space="preserve"
  >
    <g>
      <path
        d="M50.292,146.745c-0.611-8.728-7.285-15.127-15.523-14.295c-2.106-0.479-4.368-0.371-6.447,0.316
		c-4.794,1.587-7.835,6.16-9.511,10.65c-1.661,4.453-1.073,9.725,1.388,13.748c2.987,4.885,8.548,6.711,13.966,7.062
		C44.017,164.868,50.944,156.077,50.292,146.745z M35.769,154.235c-5.237,0.475-8.254-2.578-7.14-7.391
		c0.463-2.001,1.387-3.443,2.605-4.506c0.799,0.211,1.635,0.277,2.426,0.041C41.97,139.911,43.117,153.568,35.769,154.235z"
      />
      <path
        d="M147.256,132.543c-2.611-0.646-5.851-0.236-7.808,0.5c-4.25,1.601-6.995,4.992-8.381,9.231
		c-2.813,8.608,2.706,17.835,11.24,20.079c10.051,2.643,19.274-4.956,20.108-14.921
		C163.136,138.842,156.079,130.346,147.256,132.543z M152.255,147.433c-0.346,4.511-4.971,6.065-8.728,4.835
		c-3.147-1.032-3.685-5.443-3.021-8.052c0.466-1.835,1.42-2.749,2.571-3.316c0.737,1.099,2.015,1.81,3.864,1.662
		C151.323,142.209,152.604,142.874,152.255,147.433z"
      />
      <path
        d="M17.576,137.216c-2.342-1.849-4.855-1.769-7.712-1.901c-2.133-0.099-4.263-0.191-6.398-0.219
		c-4.053-0.055-4.785,5.895-0.945,6.979c2.156,0.609,4.427,0.805,6.644,1.06c2.661,0.305,5.2,0.909,7.696-0.374
		C18.732,141.798,19.329,138.599,17.576,137.216z"
      />
      <path
        d="M190.531,141.409c-1.886-0.545-3.885-0.809-5.912-0.971c0.021-0.217,0.045-0.432,0.032-0.671
		c-1.086-22.032,11.227-45.387-4.363-64.544c-5.564-6.836-17.221-20.951-25.246-24.439c-12.657-5.5-23.978-1.009-37.239,0.052
		c-2.18,0.175-3.942,1.675-3.972,3.972c-0.339,25.794-1.936,51.479-0.444,77.241c-19.204-23.58-34.325-50.343-53.683-73.701
		c-0.81-3.669-1.413-6.298-1.66-7.362c-0.131-0.561-0.349-1.02-0.627-1.39c4.035-5.726,1.335-13.876-4.204-17.81
		c-5.689-4.041-14.683-4.706-18.963,1.743c-3.284,4.947-2.75,10.256-0.009,14.517c-5.518,6.103-5.257,12.468-0.083,18.713
		c2.491,3.007,11.038,10.312,6.493,14.585c-2.581,2.427-8.596,1.488-11.463,0.23c-5.449-2.389-1.693-4.873-0.423-9.025
		c0.698-2.282-1.761-5.25-4.22-4.22c-6.941,2.908-8.467,11.865-3.581,17.282c4.311,4.779,12.148,5.656,18.085,4.523
		c6.758-1.29,10.703-6.78,9.636-13.503c-0.713-4.493-4.057-8.264-7.137-11.364c-1.709-1.72-3.529-3.335-4.895-5.355
		c-1.932-2.856-1.105-5.904,0.125-8.816c1.254,1.205,2.694,2.263,4.285,3.104c3.15,1.664,7.098,2.616,10.616,1.658
		c4.928,26.905,9.107,53.63,12.996,80.707c-3.73,0.449-7.415,1.008-11,1.762c-1.835,0.387-1.84,3.318,0,3.701
		c21.949,4.566,46.266,2.678,68.641,3.315c1.077,0.03,1.865-0.321,2.479-0.824c0.751,0.005,1.518-0.312,2.035-1.091
		c10.135-15.299,38.168-22.256,42.909,1.4c0.32,1.598,1.95,2.58,3.47,2.641c5.652,0.223,11.766,1.723,17.322,0.508
		C193.927,147.235,193.646,142.306,190.531,141.409z M50.423,47.344c-0.162,0.316-0.223,0.625-0.291,0.934
		c-1.71,0.209-3.855-0.628-5.319-1.168c-4.341-1.602-6.903-5.673-4.211-9.867c1.785-2.781,6.497-0.918,8.537,0.359
		C53.439,40.295,52.328,43.624,50.423,47.344z M69.625,136.054c-0.079-0.722-0.634-1.159-1.361-1.021
		c5.925-1.125-0.364-37.146-5.4-61.812c12.403,22.657,25.755,46.958,44.698,62.951C95.055,135.265,82.091,134.965,69.625,136.054z
		 M176.543,139.768c0.011,0.171,0.052,0.322,0.08,0.482c-0.214,0.002-0.435,0.002-0.647,0.004
		c-7.252-22.825-43.168-24.289-52.246-2.354c-0.424-0.201-0.878-0.369-1.412-0.425c-1.738-0.179-3.522-0.341-5.295-0.508
		c2.247-26.151,3.878-52.297,4.628-78.532c10.617-1.256,23.121-4.704,31.923,2.57c7.167,5.923,13.993,13.719,20.571,20.362
		C188.142,95.503,175.38,122.14,176.543,139.768z"
      />
      <path
        d="M167.819,85.235c-5.091-6.483-8.841-14.112-15.239-19.479c-6.045-5.071-15.644-3.064-22.875-3.408
		c-1.796-0.085-3.017,1.495-3.134,3.133c-0.472,6.597-1.195,13.131-0.215,19.694c-1.528,0.841-1.227,3.36,0.887,3.568
		c6.689,0.659,13.358,1.501,20.048,2.162c5.75,0.568,12.07,1.991,17.745,0.66c0.449-0.106,0.814-0.295,1.13-0.525
		C168.142,90.315,169.572,87.467,167.819,85.235z M147.29,84.22c-5.538-0.087-11.06,0.106-16.579,0.478
		c0.988-5.289,1.503-10.677,1.896-16.051c6.457-0.083,13.149-0.889,17.979,4.088c3.297,3.397,5.75,7.536,8.342,11.551
		C155.047,84.008,151.001,84.278,147.29,84.22z"
      />
    </g>
  </svg>
  <svg
    v-else-if="name === 'wheel'"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="181.576px"
    height="181.576px"
    viewBox="0 0 181.576 181.576"
    style="enable-background: new 0 0 181.576 181.576"
    xml:space="preserve"
  >
    <g>
      <path
        d="M99.665,4.379c-0.43,0.001-0.804,0.085-1.128,0.225C79.061,0.799,56.409,7.195,39.694,16.342
		C19.473,27.407,9.103,52.702,3.476,73.679c-5.944,22.161-5.208,53.06,9.677,71.8c14.972,18.851,37.082,28.975,60.782,31.608
		c25.562,2.841,50.776,0.067,72.886-13.713c19.828-12.359,29.112-37.725,33.376-59.665C189.599,55.309,149.634,4.314,99.665,4.379z
		 M175.278,97.627c-0.682,22.197-13.318,48.13-31.262,60.95c-17.483,12.492-39.304,14.728-60.141,13.876
		c-22.644-0.926-44.413-8.572-60.912-24.305C3.887,129.959,3.788,99.109,9.025,75.208c4.598-20.986,15.606-41.53,33.823-53.47
		c16.223-10.633,43.699-14.93,62.312-10.714c0.861,0.195,1.526-0.063,1.998-0.507c17.814,2.67,32.91,12.317,46.063,24.905
		C171.176,52.604,176.016,73.565,175.278,97.627z"
      />
      <path
        d="M146.416,50.519c-6.218-7.925-18.198-12.087-26.444-17.578c-8.673-5.775-16.199-6.543-25.703-7.706
		c-7.707-6.215-21.97-0.501-29.811,2.696c-17.875,7.29-32.133,24.26-36.846,42.767c-9.056,35.558,0.759,73.786,37.886,86.66
		c40.902,14.184,80.324-13.475,91.601-52.444C162.532,86.143,158.372,65.757,146.416,50.519z M153.148,99.106
		c-5.729,38.279-41.389,61.343-78.323,55.49c-34.742-5.504-46.696-37.098-44.004-68.436C32.603,65.435,42.063,49.528,58.97,37.42
		c6.587-4.718,20.616-10.387,30.302-8.883c0.268,0.389,0.645,0.703,1.193,0.817c1.062,0.221,2.129,0.395,3.196,0.568
		c0.288,0.15,0.594,0.275,0.865,0.447c0.574,0.367,1.199,0.277,1.688-0.04c3.548,0.526,7.095,1.017,10.567,2.053
		c7.52,2.243,14.354,8.462,21.047,12.435c11.022,6.543,18.452,12.181,23.011,24.86C154.271,79.214,154.634,89.179,153.148,99.106z"
      />
      <path
        d="M90.76,77.761c-0.115-0.181-0.271-0.328-0.506-0.364c-7.39-1.128-12.774,4.065-12.918,11.499
		c-0.131,6.761,4.829,13.236,11.363,14.814c7.561,1.826,16.967-3.657,16.54-11.938C104.894,85.1,97.652,78.284,90.76,77.761z
		 M88.692,98.394c-3.758-1.282-5.825-5.825-6.013-9.497c-0.176-3.439,1.778-5.904,4.327-7.74c0.196,0.166,0.422,0.302,0.719,0.354
		c5.777,1.015,10.305,3.423,12.212,9.35C101.96,97.146,93.396,99.998,88.692,98.394z"
      />
      <path
        d="M145.277,104.399c0.797-0.879-0.404-2.231-1.454-1.665c-8.732,4.715-21.521-0.905-21.262-11.447
		c0.127-5.163,4.958-8.475,9.372-9.84c4.328-1.338,8.15,0.811,12.245,0.103c0.952-0.164,1.521-1.325,1.3-2.25
		c0.23-0.085,0.445-0.215,0.589-0.437c3.087-4.757-0.473-13.608-4.419-17.013c-1.386-1.195-8.58-6.858-11.205-6.496
		c-0.252-1.113-1.605-1.724-2.723-1.183c-6.684,3.242-13.762,16.286-22.424,9.556c-2.646-2.056-3.063-7.448-3.233-10.463
		c-0.198-3.517,0.488-6.593,2.604-9.405c0.57-0.757-0.202-1.884-1.065-1.857c-10.184,0.327-7.557,20.369-2.948,25.258
		c4.152,4.407,10.437,5.1,15.795,2.575c4.67-2.2,10.573-6.429,13.114-11.433c1.262,2.575,4.658,4.378,6.765,5.92
		c2.202,1.613,3.4,3.21,4.714,5.626c1.231,2.263,1.522,4.815,2.369,7.171c-4.049-2.458-10.848-1.05-14.706,0.537
		c-5.863,2.412-9.943,7.316-10.669,13.628c-1.408,12.236,12.609,19.677,22.83,15.782c-1.378,5.135-3.451,9.312-7.157,13.416
		c-1.285,1.423-3.243,3.247-4.452,5.252c-1.761-4.564-5.735-9.144-9.071-11.6c-6.097-4.488-12.339-3.284-17.73,1.664
		c-4.431,4.067-4.74,11.294-3.75,16.762c0.591,3.262,2.422,7.689,5.365,10.052c-3.446,0.175-7.008,1.183-10.423,1.319
		c-3.977,0.159-7.977-0.128-11.812-1.144c5.417-8.28,4.346-26.445-5.809-29.403c-5.397-1.573-11.262,0.456-15.549,3.865
		c-2.398,1.906-5.771,5.722-5.79,9.271c-1.281-0.769-2.612-1.395-3.779-2.457c-2.063-1.879-3.742-4.168-5.24-6.506
		c-1.321-2.062-2.542-4.224-3.52-6.47c-0.1-0.23-0.287-0.728-0.505-1.257c10.143,2.849,23.146-7.066,22.96-17.301
		c-0.182-10.025-12.945-13.461-21.491-13.159c-0.095-4.671,1.153-8.359,3.591-12.403c1.184-1.964,2.706-3.667,4.296-5.304
		c0.614-0.632,1.304-1.158,1.971-1.698c0.821,7.666,13.66,10.486,20.288,9.315c5.913-1.045,10.982-6.349,11.835-12.224
		c0.7-4.825-1.769-11.386-5.692-14.93c3.419-1.325,6.988-1.848,10.717-1.903c3.907-0.058,7.729,2.281,11.422,1.762
		c1.121-0.157,1.455-1.607,1-2.458c-2.015-3.767-8.665-3.8-12.422-3.885c-5.069-0.115-10.504,1.25-14.62,4.25
		c-1.001,0.729-0.986,1.87-0.448,2.613c1.107,3.907,3.947,7.092,4.856,11.206c1.07,4.843-2.712,9.182-7.125,10.564
		c-3.15,0.986-6.683,0.55-9.775-0.391c-4.16-1.265-5.801-4.013-6.144-8.125c-0.105-1.263-1.786-2.121-2.656-1.167
		c-0.215-0.079-0.444-0.133-0.702-0.125c-5.09,0.167-9.532,7.093-11.867,11.006c-2.428,4.067-4.256,10.426-1.322,14.671
		c-0.466,0.696-0.38,1.719,0.674,1.934c6.406,1.308,16.677,1.268,19.063,8.93c1.759,5.651-3.19,10.092-7.941,11.703
		c-3.949,1.339-7.846,0.934-11.802,1.777c-1.66,0.354-2.29,2.525-1.45,3.846c-1.973,2.716,0.934,8.143,2.373,10.771
		c2.22,4.058,8.315,13.474,14.167,11.325c0.32-0.117,0.549-0.308,0.745-0.515c0.7,0.345,1.583,0.073,1.873-0.804
		c1.172-3.538,2.227-5.792,5.316-8.16c3.058-2.346,7.89-4.341,11.658-2.63c3.671,1.666,4.591,7.808,4.866,11.252
		c0.373,4.672-0.901,8.757-3.163,12.766c-1.018,1.803,0.74,3.502,2.394,3.111c3.825,2.5,8.348,3.183,12.975,3.514
		c4.845,0.346,11.823,0.082,15.719-3.148c0.553-0.458,0.67-1.033,0.535-1.571c0.1,0.002,0.193,0.019,0.296,0.016
		c0.835-0.021,1.576-1.023,1.029-1.794c-2.173-3.06-4.362-5.302-5.479-9.025c-1.25-4.174-1.036-9.173,1.213-12.945
		c3.411-5.725,9.504-4.378,13.474-0.529c3.436,3.332,4.659,8.387,8.111,11.552c0.899,0.824,2.261,0.61,2.882-0.268
		c0.205-0.015,0.41-0.071,0.599-0.193c3.446-2.228,6.845-6.138,9.506-9.254c3.598-4.213,6.391-9.976,6.241-15.591
		C146.167,105.423,145.792,104.822,145.277,104.399z"
      />
    </g>
  </svg>
  <svg
    v-else-if="name === 'truck'"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="189.628px"
    height="189.628px"
    viewBox="0 0 189.628 189.628"
    style="enable-background: new 0 0 189.628 189.628"
    xml:space="preserve"
  >
    <g>
      <path
        d="M134.716,115.517c-5.952-2.723-13.462-1.906-19.774-1.731c-14.078,0.392-28.104,0.165-42.149,1.39
		c-19.598,1.709-42.943,2.485-62.624-0.289c-0.889-0.125-1.598,0.211-2.097,0.721c-0.22,0.072-0.442,0.129-0.654,0.283
		c-6.366,4.648-9.626,15.638-3.194,22.103c11.356,11.414,33.29,7.851,47.759,7.909c24.601,0.102,49.535,3.511,73.942-1.151
		C142.065,141.667,156.363,125.421,134.716,115.517z M132.904,121.347c-0.148-0.147-0.303-0.262-0.455-0.39
		c0.564,0.214,1.113,0.445,1.654,0.691c-0.418,0.565-0.5,1.379,0.069,1.942c2.329,2.311,2.899,3.993,1.239,7.01
		c-1.309,2.381-4.26,4.772-7.142,4.265c-3.459-0.61-3.549-4.478-2.767-7.147c0.901-3.08,3.52-4.656,6.61-4.463
		C133.107,123.317,133.568,122.001,132.904,121.347z M122.223,119.081c1.509-0.09,3.417,0.091,5.433,0.498
		c-2.974,0.513-5.748,3.175-7.033,6.081c-0.268,0.605-0.457,1.225-0.621,1.844c-1.843-4.44-6.429-7.757-11.243-7.559
		c-0.017-0.129-0.059-0.25-0.106-0.373C113.176,119.48,117.7,119.351,122.223,119.081z M10.707,120.154
		c0.162-0.125,0.237-0.282,0.351-0.425c2.161,0.418,4.422,0.573,6.693,0.651c-2.809,1.973-4.608,5.633-4.367,9.395
		c0.29,4.516,2.885,7.801,6.387,9.602C11.725,138.668,8.669,132.3,10.707,120.154z M28.256,134.974
		c-4.236,1.47-8.387-1.211-9.249-5.4c-0.685-3.331,1.366-5.143,3.875-6.283c0.38,0.358,0.934,0.561,1.569,0.452
		c3.445-0.581,5.41,0.188,6.533,3.748C31.856,130.257,31.318,133.913,28.256,134.974z M35.137,140.099
		c-1.403,0.011-2.803-0.019-4.203-0.071c5.215-2.228,6.741-8.698,4.974-13.894c-0.697-2.05-2.273-4.16-4.2-5.582
		c6.966,0.125,13.912,0.211,20.857,0.217c-4.254,1.017-7.248,6.17-7.439,10.555c-0.158,3.618,1.354,6.8,3.791,8.911
		C44.323,140.183,39.728,140.158,35.137,140.099z M57.572,137.208c-3.699,1.148-6.647-1.81-6.909-5.286
		c-0.285-3.791,1.451-5.787,4.245-7.188c0.116,0.033,0.189,0.113,0.321,0.125c3.627,0.308,5.213,0.938,5.969,4.773
		C61.761,132.493,60.548,136.284,57.572,137.208z M77.78,141.421c-5.115-0.279-10.222-0.572-15.337-0.809
		c3.108-2.616,4.464-7.089,3.852-11.285c-0.555-3.803-3.901-8.232-7.789-8.587c5.568-0.043,11.141-0.174,16.723-0.396
		c-3.557,2.531-4.199,7.785-2.992,12.175c1.246,4.53,4.683,7.866,8.85,9.083C79.983,141.542,78.874,141.481,77.78,141.421z
		 M77.176,123.983c0.233,0.067,0.475,0.104,0.718,0.062c4.72-0.799,9.31-1.287,12.256,3.276c2.823,4.373-0.359,8.261-4.719,9.489
		C78.826,138.673,74.445,129.386,77.176,123.983z M86.648,141.894c0.312-0.055,0.621-0.061,0.934-0.141
		c7.5-1.921,10.875-9.717,7.274-16.414c-1.364-2.535-3.634-4.386-6.219-5.449c4.312-0.094,8.625-0.142,12.938-0.196
		c-2.304,1.927-3.811,5.317-4.357,8.04c-1.147,5.709,0.742,11.924,5.965,14.582C97.66,142.366,92.122,142.171,86.648,141.894z
		 M105.646,137.446c-5.159-1.603-4.476-13.125,0.326-15.245c0.152,0.521,0.528,0.982,1.111,1.152
		c4.339,1.259,8.341,3.238,8.435,8.363C115.609,136.654,109.658,138.693,105.646,137.446z M114.906,141.735
		c2.631-1.601,4.666-4.12,5.513-7.116c0.998,2.385,2.889,4.365,5.652,5.408C122.403,140.82,118.676,141.378,114.906,141.735z"
      />
      <path
        d="M140.375,73.438c-4.631-4.631-12.658-2.489-18.921-1.93c0.09-6.162-0.924-15.694-8.073-15.874
		c-7.85-0.198-8.595,7.769-7.314,14.04c-6.441,1.221-12.924,2.302-19.467,2.1c1.229-7.364,4.175-19.559-2.643-23.443
		c-4.912-2.798-16.582-1.918-23.287,0.683c-0.027-1.117-0.132-2.218-0.225-3.37c-0.112-1.381-1.046-2.438-2.482-2.482
		c-6.22-0.189-18.35-3.248-21.171,4.725c-2.2,6.217-1.24,14.677,0.433,21.494c-5.327-1.552-12.426-1.097-17.696-1.313
		c-4.11-0.169-12.16-0.926-15.319,2.659c-7.262,8.241-3.332,24.109-1.399,34.18c-0.563,0.661-0.485,1.865,0.564,2.071
		c43.938,8.632,89.539,2.242,133.813,2.66c0.76,0.008,1.227-0.442,1.41-1.002c1.439,0.729,3.691,0.035,3.831-2.11
		C142.995,97.79,147.559,80.621,140.375,73.438z M137.41,106.526c-0.001,0.021,0.009,0.034,0.008,0.055
		c-0.079-0.01-0.143-0.046-0.23-0.045c-43.873,0.585-87.953-2.569-131.827-2.073C6.2,95.106,3,83.91,7.15,75.391
		c1.824-3.744,12.459-1.818,15.691-1.573c4.702,0.357,11.305,2.301,15.86,0.695c1.044-0.368,1.573-1.152,1.677-1.985
		c0.003-0.011,0.014-0.014,0.017-0.025c1.542-6.03-0.057-12.754,0.365-18.926c0.299-4.365,1.773-5.752,6.173-5.951
		c2.944-0.133,5.889,0.222,8.831,0.4c0.093,0.766,0.217,1.528,0.261,2.3c-0.017,0.88,0.364,1.466,0.892,1.827
		c0.104,0.655,0.585,1.229,1.434,1.262c6.622,0.26,13.272-0.733,19.909-0.606c7.725,0.147,3.434,16.322,2.924,21.323
		c-0.102,1.003,0.841,2.301,1.861,2.443c8.488,1.185,16.506,0.12,24.799-1.821c1.191-0.279,1.756-1.087,1.874-1.98
		c0.002-0.004,0.002-0.009,0.003-0.013c0.008-0.064,0.033-0.122,0.036-0.187c0.032-0.126,0.073-0.247,0.075-0.393
		c0.021-1.074,0.03-2.148,0.03-3.222c0.003-0.631,1.303-12.264,5.433-6.444c2.014,2.839,1.324,8.301,1.039,11.617
		c-0.12,1.413,1.235,2.443,2.508,2.507c5.309,0.269,10.836-1.205,16.079-0.272C141.447,77.531,137.639,101.794,137.41,106.526z"
      />
      <path
        d="M187.142,118.871c-15.296-0.809-20.058-18.471-17.996-31.225c0.186-1.152-0.283-2.729-1.665-2.932
		c-4.844-0.713-9.793-0.76-14.683-0.875c-1.969-0.046-2.785,1.418-2.624,2.861c-0.186,0.106-0.377,0.203-0.51,0.403
		c-8.147,12.403-4.773,34.425,9.495,40.917c7.987,3.633,29.931,7.277,30.467-6.662C189.682,119.95,188.454,118.941,187.142,118.871z
		 M159.994,121.667c-11.239-5.811-8.113-21.973-7.809-32.46c0.202,0.069,0.382,0.168,0.613,0.197
		c3.786,0.478,7.702,0.232,11.554,0.077c-0.48,14.638,3.604,29.048,18.285,33.386C176.782,127.63,166.23,124.892,159.994,121.667z"
      />
      <path
        d="M76.763,85.675c-1.036-6.773-1.687-14.741-0.395-21.523c0.16-0.84-0.067-1.975-0.96-2.36
		c-8.171-3.522-17.478-2.042-26.05-3.693c-1.799-0.347-3.644,0.789-3.631,2.766c0.027,3.872-1.287,8.812,0.683,12.359
		c0.151,0.683,0.62,1.3,1.573,1.571c6.663,1.896,11.867,6.173,12.979,13.288c0.229,1.467,1.899,2.003,3.143,1.784
		c3.732-0.655,7.519-0.676,11.196-1.614C76.501,87.946,76.933,86.786,76.763,85.675z M50.643,70.689
		c0.48-2.125,0.641-4.764,0.718-6.872c7.04,0.187,14.004,1.258,21.012,1.72c0.287,6.222-0.423,12.44,0.087,18.702
		c-2.376,0.09-4.75,0.155-7.112,0.38C63.358,77.842,57.558,72.29,50.643,70.689z"
      />
    </g>
  </svg>
  <svg
    v-else-if="name === 'banknote'"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="482.314px"
    height="482.313px"
    viewBox="0 0 482.314 482.313"
    style="enable-background: new 0 0 482.314 482.313"
    xml:space="preserve"
  >
    <g>
      <g>
        <path
          d="M464.823,75.148c-135.805,2.098-313.885,7.069-449.652,2.555c-5.558-0.188-8.747,3.29-9.681,7.441
			c-0.119,0.353-0.277,0.686-0.345,1.059c-0.884,4.667-1.242,9.297-1.242,14.03c-3.504,49.774-2.75,146.447-3.9,196.296
			c-0.041,1.823,0.328,3.372,0.967,4.697c1.107,4.058,4.238,7.688,9.433,8.303c138.367,16.396,319.098,4.123,457.589-3.899
			c2.468-0.147,4.474-0.98,6.032-2.234c4.606-0.584,8.628-3.859,8.268-9.897c-3.266-53.976-3.463-154.812-3.469-208.864
			C478.823,76.347,470.891,73.194,464.823,75.148z M20.927,289.843c0.947-47.626,0.426-142.062,3.775-189.609
			c0-0.5,0.021-0.998,0.025-1.498c130.362,3.91,302.939-0.571,433.322-2.671c0.051,47.484,0.452,141.747,3.052,189.172
			C328.388,293.053,153.528,304.184,20.927,289.843z"
        />
        <path
          d="M284.83,194.377c-10.502-8.391-23.491-12.111-36.747-14.825c-0.442-11.095-0.889-22.193-1.384-33.289
			c5.773,1.27,11.304,3.125,16.001,5.299c11.491,5.304,17.687-13.312,6.348-18.548c-6.729-3.105-14.787-5.522-23.232-6.822
			c-0.035-0.771-0.073-1.541-0.099-2.305c-0.541-12.495-20.111-13.81-19.565-1.186c0.035,0.907,0.076,1.811,0.114,2.714
			c-12.553,1.011-24.41,5.195-32.522,14.091c-14.945,16.387-3.867,44.684,15.465,51.684c6.401,2.318,13.162,3.712,20,4.918
			c0.521,14.98,0.843,29.968,1.039,44.961c-8.962-4.215-17.118-10.438-22.186-15.965c-8.548-9.308-23.234,3.664-14.675,12.995
			c8.574,9.344,22.338,18.661,37.013,23.679c-0.01,2.001,0.045,3.991,0.036,5.986c-0.069,12.589,19.494,13.843,19.57,1.184
			c0.005-1.147-0.035-2.295-0.021-3.443c10.069,0.209,19.683-2.519,27.452-9.698C294.041,240.48,305.868,211.193,284.83,194.377z
			 M219.91,173.92c-12.464-3.121-19.306-18.578-5.423-25.552c3.841-1.93,8.152-2.988,12.646-3.463
			c0.452,10.303,0.873,20.601,1.29,30.904C225.536,175.235,222.688,174.619,219.91,173.92z M263.044,242.1
			c-3.95,2.677-8.47,3.799-13.197,3.845c-0.163-15.402-0.485-30.804-1-46.195c8.191,1.886,16.097,4.56,23.176,9.394
			C283.829,217.2,271.236,236.527,263.044,242.1z"
        />
        <path
          d="M467.56,310.83c-150.745,12.924-302.254,19.576-453.258,6.932c-13.373-1.117-13.264,19.688,0,20.8
			c151.004,12.639,302.513,5.986,453.258-6.932C480.819,330.492,480.925,309.678,467.56,310.83z"
        />
        <path
          d="M467.56,342.029c-150.745,12.924-302.254,19.575-453.258,6.932c-13.373-1.117-13.264,19.688,0,20.8
			c151.004,12.639,302.513,5.986,453.258-6.932C480.819,361.691,480.925,340.877,467.56,342.029z"
        />
        <path
          d="M467.56,373.229c-150.745,12.924-302.254,19.575-453.258,6.932c-13.373-1.117-13.264,19.688,0,20.799
			c151.004,12.64,302.513,5.987,453.258-6.931C480.819,392.891,480.925,372.076,467.56,373.229z"
        />
        <path
          d="M87.725,137.788c0-0.173,0.041-0.333,0.025-0.505c-0.521-6.764-2.531-13.401-7.884-17.936
			c-5.583-4.735-12.916-6.14-20.065-5.464c-0.566,0.051-1.122,0.162-1.658,0.302c-6.578,0.69-12.601,3.151-17.503,7.835
			c-0.666,0.635-1.132,1.315-1.508,2.003c-0.442,0.645-0.843,1.335-1.147,2.089c-2.158,5.284-2.669,10.895-1.531,16.448
			c-0.129,1.539,0.178,3.115,1.016,4.512c3.285,5.512,7.924,9.636,13.198,13.197c0.368,0.249,0.769,0.437,1.175,0.6
			c0.587,0.338,1.231,0.635,1.991,0.838c8.351,2.229,16.775,0.998,24.204-3.387c0.843-0.498,1.488-1.092,2.034-1.722
			c0.069-0.051,0.135-0.092,0.198-0.145c5.256-4.591,8.178-11.54,7.482-18.517C87.746,137.882,87.73,137.839,87.725,137.788z
			 M71.76,142.409c-0.01-0.239-0.909,1.513-1.082,1.765c0.599-0.874-0.681,0.478-1.211,1.013c-3.519,1.892-7.066,2.486-10.991,1.554
			c-2.361-1.607-4.816-3.758-6.642-6.282c-0.036-0.233-0.046-0.467-0.109-0.701c-0.637-2.511-0.373-4.669,0.396-7.061
			c2.501-2.188,5.482-3.15,8.985-3.214c0.437-0.011,0.823-0.084,1.222-0.145c2.574-0.048,4.92,0.279,6.703,1.295
			c0.863,0.488,1.348,1.148,1.894,2.036c0.67,1.099,1.097,2.887,1.227,4.614c0.005,0.04,0.015,0.078,0.021,0.114
			c0,0.183-0.041,0.353-0.021,0.535c0.099,0.947,0.104,1.872,0.063,2.818C72.156,140.602,71.907,141.777,71.76,142.409z"
        />
        <path
          d="M446.517,132.588c0-0.173,0.04-0.333,0.025-0.505c-0.523-6.764-2.534-13.401-7.886-17.936
			c-5.581-4.735-12.914-6.139-20.063-5.464c-0.568,0.051-1.122,0.163-1.66,0.302c-6.576,0.691-12.599,3.151-17.504,7.835
			c-0.665,0.635-1.133,1.315-1.509,2.003c-0.441,0.645-0.843,1.336-1.147,2.09c-2.158,5.284-2.666,10.895-1.528,16.447
			c-0.132,1.539,0.178,3.115,1.016,4.512c3.285,5.513,7.922,9.636,13.197,13.198c0.366,0.249,0.768,0.437,1.174,0.599
			c0.589,0.338,1.233,0.635,1.99,0.838c8.354,2.229,16.777,0.998,24.207-3.387c0.843-0.498,1.487-1.092,2.031-1.722
			c0.07-0.051,0.137-0.091,0.197-0.145c5.256-4.59,8.181-11.54,7.485-18.517C446.538,132.682,446.522,132.639,446.517,132.588z
			 M430.552,137.209c-0.011-0.238-0.909,1.514-1.082,1.765c0.6-0.873-0.681,0.478-1.214,1.013
			c-3.519,1.892-7.063,2.486-10.988,1.554c-2.361-1.607-4.819-3.758-6.643-6.282c-0.035-0.234-0.045-0.467-0.111-0.701
			c-0.635-2.511-0.371-4.669,0.396-7.061c2.503-2.188,5.484-3.151,8.987-3.214c0.437-0.01,0.823-0.084,1.219-0.145
			c2.575-0.048,4.921,0.279,6.703,1.295c0.863,0.487,1.351,1.147,1.895,2.036c0.67,1.1,1.097,2.887,1.229,4.613
			c0.005,0.041,0.016,0.079,0.021,0.114c0,0.183-0.041,0.353-0.021,0.536c0.097,0.947,0.102,1.872,0.061,2.818
			C430.948,135.401,430.699,136.577,430.552,137.209z"
        />
      </g>
    </g>
  </svg>
  <svg
    v-else-if="name === 'fire'"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="489.246px"
    height="489.245px"
    viewBox="0 0 489.246 489.245"
    style="enable-background: new 0 0 489.246 489.245"
    xml:space="preserve"
  >
    <g>
      <g>
        <path
          d="M427.197,175.171c-24.369,0.442-47.378,5.487-68.177,15.765c12.618-44.96-0.03-90.561-36.933-125.7
			c-0.934-1.247-2.006-2.184-3.174-2.844c-10.892-7.83-25.628,7.447-15.32,17.258c7.109,14.096,16.062,47.984-4.067,56.33
			c-9.358,3.885-19.667-12.989-23.333-18.911c-17.209-27.789-19.312-65.19-4.479-94.206c0.254-0.188,0.487-0.401,0.741-0.587
			c11.253-8.155,1.828-26.354-9.399-21.449c-3.347,0.165-6.622,1.788-8.851,5.52c-0.27,0.46-0.487,0.958-0.757,1.422
			c-51.014,41.271-71.666,106.488-46.974,169.328c0.535,1.355,1.269,2.47,2.092,3.458c4.639,11.913,10.367,33.809-5.164,39.402
			c-25.385,9.138-34.533-29.98-42.343-45.658c-15.143-30.385-47.205-50.168-77.602-62.731
			c-11.934-4.936-17.997,11.035-10.758,19.192c17.735,52.39-4.073,96.608-16.359,147.226c-8.721,35.927-7.51,74.078,6.165,108.558
			c24.991,63.018,88.778,96.131,153.434,101.864c68.896,6.108,160.162-20.957,191.884-87.483
			c30.393-63.744,6.449-139.726,27.904-206.382C441.222,187.863,438.404,174.968,427.197,175.171z M175.25,309.417
			c7.561,5.637,13.431,12.563,17.405,20.389l0.193,0.726c4.103,11.812,13.967,25.608,28.267,25.608c2.13,0,4.319-0.319,6.5-0.935
			c5.782-1.64,10.187-5.306,12.738-10.612c4.441-9.242,2.407-21.114-0.686-28.468c-0.256-0.609-0.576-1.178-0.998-1.757
			c-5.632-15.152-5.348-31.077,0.597-45.031c1.269,15.909,8.028,30.244,18.717,38.918c8.435,6.829,19.322,6.474,26.64-0.976
			c2.031-2.057,3.682-4.372,4.971-6.921c2.596,12.187,0.021,25.024-7.611,37.557c-0.178,0.294-0.31,0.568-0.462,0.914
			c-1.63,2.392-1.818,5.353-0.482,8.008c2.498,4.966,9.48,6.565,13.614,2.631c8.332-7.947,18.483-13.056,30.213-15.209
			c-2.944,13.568-3.229,27.441-3.503,40.898c-0.295,14.197-0.589,28.883-4.073,42.868c-7.724,31.047-45.631,44.95-79.765,44.95
			c-2.476,0-4.893-0.076-7.249-0.219c-33.581-2.066-60.86-23.638-67.882-53.679c-4.489-19.2,1.48-38.41,7.259-56.985
			C174.783,335.559,176.576,322.107,175.25,309.417z M393.276,372.821c-9.395,37.739-38.791,62.154-74.077,76.423
			c4.103-4.555,7.621-9.612,10.308-15.249c8.622-18.088,8.846-38.141,9.064-57.533c0.178-15.681,0.355-31.89,5.042-46.743
			c1.854-2.574,2.184-6.169,0.798-9.104c-1.331-2.833-4.067-4.515-7.48-4.515c0,0,0,0-0.005,0
			c-11.055,0.203-21.353,2.229-30.681,6.033c4.367-22.171-2.976-44.092-20.358-60.601c-0.67-0.894-1.478-1.62-2.168-1.991
			c-4.407-3.153-11.075-0.863-13.061,4.104c-1.163,2.895-0.543,5.951,1.646,8.271c2.534,5.221,5.037,14.752,2.925,20.435
			c-0.752,2.016-2.001,3.366-4.291,4.22c-1.279,0-3.712-1.478-8.145-8.628c-8.155-13.167-9.105-31.001-2.418-44.582
			c3.032-2.298,4.221-6.139,3.017-9.841c-1.462-4.515-5.981-7.074-10.054-5.561c-2.564,0.271-4.718,1.686-6.104,4.02l-0.198,0.36
			c-27.05,22.155-36.528,56.751-24.133,88.296c0.297,0.741,0.686,1.427,1.191,2.087c2.252,5.931,2.818,10.918,1.539,13.721
			c-0.546,1.198-1.419,1.985-2.75,2.463c-0.988,0.355-1.94,0.538-2.818,0.538c-6.251,0-10.151-9.684-13-16.763
			c-0.854-2.122-1.638-4.062-2.397-5.58c-6.751-13.538-20.406-24.628-40.585-32.972c-4.009-1.65-8.049-0.005-9.78,3.839
			c-1.419,3.153-0.993,6.917,1.033,9.552c6.568,19.886,1.404,37.638-4.06,56.427c-1.519,5.226-3.09,10.618-4.431,16.143
			c-4.763,19.611-3.646,39.146,3.229,56.482c4.535,11.426,11.71,21.373,20.949,29.514c-45.697-15.955-82.434-51.562-94.003-101.047
			c-9.13-39.055,2.917-78.287,14.447-115.369c9.953-32.02,15.043-62.122,9.254-93.648c19.5,12.106,35.396,28.392,46.093,49.658
			c0.099,0.406,0.145,0.792,0.289,1.208c9.044,26.03,31.377,54.337,62.472,45.519c30.747-8.721,30.549-46.425,20.498-70.33
			c-0.478-1.133-1.102-2.085-1.788-2.953c-14.79-39.154-10.316-79.422,10.788-111.911c-2.506,34.911,8.701,71.846,35.195,93.328
			c14.462,11.725,32.489,11.974,45.763-1.528c7.638-7.774,11.888-17.062,13.711-26.906c11.796,29.462,8.419,62.055-10.882,93.742
			c-0.346,0.563-0.564,1.115-0.803,1.666c-7.663,10.347,7.627,24.57,17.92,14.767c19.946-19.009,43.752-29.239,70.036-32.593
			C395.439,256.505,407.433,315.896,393.276,372.821z"
        />
      </g>
    </g>
  </svg>

  <svg
    v-else-if="name === 'reports-up'"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="467.986px"
    height="467.986px"
    viewBox="0 0 467.986 467.986"
    style="enable-background: new 0 0 467.986 467.986"
    xml:space="preserve"
  >
    <g>
      <g>
        <path
          d="M449.613,68.18c-0.035-1.404-0.289-2.656-0.64-3.836c-0.716-6.231-5.053-12.157-13.056-12.594
			c-22.811-1.244-45.626-1.368-68.461-1.368c-3.621,0-6.454,1.186-8.593,3.016c-4.407,1.836-7.835,5.82-7.84,12.048
			c-0.041,124.599-1.33,249.191-1.371,373.79c0,1.563,0.274,2.945,0.67,4.235c0.863,6.078,5.2,11.76,13.021,12.197
			c24.638,1.371,49.261,2.64,73.94,2.741c0.467,0,0.857-0.116,1.3-0.152c0.478,0.051,0.949,0.152,1.437,0.152
			c20.83,0,12.705-31.3,13.233-43.767c0.722-16.966,1.204-33.937,1.503-50.906c0.59-32.855,0.457-65.72-0.051-98.574
			C453.69,199.481,451.111,133.846,449.613,68.18z M425.081,430.836c-16.016-0.299-32.011-0.979-48.012-1.822
			c0.097-117.063,1.203-234.123,1.315-351.193c14.711,0.054,29.417,0.193,44.117,0.734
			C425.427,195.982,431.104,313.413,425.081,430.836z"
        />
        <path
          d="M322.272,157.182c-0.111-2.912-1.016-5.299-2.336-7.254c-2.025-4.02-5.799-7.224-11.354-7.81
			c-22.476-2.376-44.696-1.326-67.088,1.366c-2.569,0.308-4.718,1.224-6.533,2.471c-5.225,1.31-9.312,5.461-8.533,12.591
			c10.374,94.633,6.002,190.063,15.059,284.788c0.084,0.858,0.27,1.646,0.473,2.422c-0.138,6.947,4.25,14.011,13.223,14.011
			c14.838,0,79.552,10.303,76.678-16.396C321.45,348.258,326.071,252.584,322.272,157.182z M267.999,432.39
			c-7.449-87.483-4.529-175.515-13.091-262.917c13.457-1.173,26.894-1.609,40.38-0.955c2.915,87.981-0.477,176.166,8.09,263.872
			H267.999z"
        />
        <path
          d="M202.141,233.141c-1.127-5.484-5.309-9.821-12.677-8.866c-19.56,2.528-39.207,4.072-58.872,5.477
			c-1.036,0.073-2.003,0.254-2.917,0.5c-6.975-0.167-13.883,4.199-13.515,13.188c2.734,67.08,5.403,134.155,6.848,201.271
			c0.063,2.854,0.878,5.189,2.123,7.13c1.092,5.723,5.388,10.714,12.936,10.674c16.9-0.092,33.764-1.274,50.663-1.371
			c2.138-0.011,3.999-0.437,5.622-1.152c8.038,2.381,18.07-1.758,17.658-12.538c-2.635-68.893-4.098-137.821-5.477-206.744
			C204.466,237.64,203.55,235.136,202.141,233.141z M148.142,434.898c-1.384-59.574-3.667-119.109-6.083-178.648
			c11.791-0.898,23.58-1.884,35.337-3.179c1.216,60.266,2.575,120.536,4.753,180.771
			C170.807,434.025,159.476,434.573,148.142,434.898z"
        />
        <path
          d="M71.017,345.979c-13.431-1.133-26.898-1.219-40.377-1.225c-1.508,0-2.833,0.265-4.083,0.625
			c-6.197,0.736-12.027,5.073-12.35,13.065c-1.246,31.026-1.366,62.068-1.366,93.11c0,1.391,0.218,2.641,0.536,3.809
			c0.437,6.469,4.789,12.623,13.154,12.623h46.555c7.145,0,11.347-4.494,12.708-9.831c2.232-2.193,3.725-5.275,3.725-9.333v-90.367
			C89.514,347.512,79.015,343.368,71.017,345.979z M62.131,440.606H40.27c0.041-22.811,0.198-45.61,0.883-68.4
			c7,0.051,13.993,0.162,20.978,0.528V440.606z"
        />
        <path
          d="M41.248,227.534c3.608,0,7.104-1.247,10.379-3.712C95.051,191.15,192.812,107.321,238.083,66.065
			c-0.254,7.596-0.396,14.627-0.421,21.266c-0.021,5.145,1.731,9.641,5.08,13c3.459,3.468,8.465,5.466,13.752,5.466
			c9.379,0,18.899-6.33,18.95-18.417c0.102-22.204,1.433-44.798,2.732-66.809c0.305-5.185-1.234-9.725-4.453-13.134
			c-3.275-3.473-8.15-5.492-13.416-5.538c-1.173-0.276-2.311-0.441-3.458-0.516C234.911,0.109,213.102,0,190.837,0l0,0
			c-12.105,0-18.438,9.501-18.443,18.885c-0.005,9.387,6.332,18.893,18.443,18.898c7.389,0,14.772,0.021,22.16,0.089
			C168.311,78.717,73.305,160.446,31.562,191.859c-7.051,5.304-9.646,13.926-6.787,22.5
			C27.405,222.243,34.024,227.534,41.248,227.534z"
        />
      </g>
    </g>
  </svg>

  <svg
    v-else-if="name === 'user-menu'"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="474.5px"
    height="474.5px"
    viewBox="0 0 474.5 474.5"
    style="enable-background: new 0 0 474.5 474.5"
    xml:space="preserve"
  >
    <g>
      <g>
        <path
          d="M120.252,169c15.843,11.233,33.784,17.167,51.879,17.167c23.687,0,47.017-9.958,65.688-28.043
			c4.979-4.827,10.189-10.468,11.591-12.131c0.609-0.729,1.163-1.566,1.646-2.476c17.936-33.883,14.934-68.928-8.227-96.151
			c-5.497-6.457-10.369-11.933-12.121-13.627c-0.901-0.868-2.008-1.645-3.283-2.3c-16.123-8.292-32.451-12.5-48.53-12.5
			c-22.099,0-43.439,7.836-63.416,23.285c-0.899,0.696-1.668,1.455-2.283,2.247c-1.424,1.836-6.033,8.127-10.146,14.157
			C76.479,97.605,83.556,142.99,120.252,169z M131.753,63.812c0.406-0.432,0.769-0.883,1.102-1.34
			c1.404-1.945,7.426-7.185,14.416-10.697c15.282-7.681,32.388-9.328,49.435-4.783c7.992,2.133,19.042,8.955,24.62,15.208
			c14.429,16.161,18.984,34.974,13.178,54.398c-2.184,7.305-5.746,13.784-6.965,15.068c-13.238,17.778-31.77,27.424-52.417,27.424
			c-25.21,0-49.13-14.665-58.166-35.668C112.104,112.134,107.56,89.369,131.753,63.812z"
        />
        <path
          d="M346.358,286.354c-8.18,0.208-15.935,0.427-22.901,0.66c0.143,2.488,0.32,4.986,0.447,7.475
			c1.193,24.521,1.976,49.048,2.579,73.59c0.335,13.903,0.462,27.807,0.528,41.711c-16.417,0.015-32.819,0.188-49.221,1.035
			c-0.884-35.159-2.671-79.236-4.148-105.602c-0.808-14.432-23.318-14.513-22.506,0c1.833,32.764,4.164,93.019,4.621,129.347
			c-51.56-0.193-103.116-1.006-154.678-1.184c-0.16-36.19-0.843-94.439-0.904-126.294c-0.025-14.513-22.531-14.513-22.505,0
			c0.045,23.714,0.437,62.083,0.703,95.075c-18.184,0.838-36.383,1.021-54.583,1.051c-2.544-50.525-0.589-101.042,0.421-151.604
			c4.581-9.449,11.824-16.328,21.896-19.646c31.91-3.361,63.987-4.74,96.06-5.21c32.194-0.467,64.391,0.016,96.578,0.355
			c11.44,0.12,22.871-0.033,34.312-0.089c3.147-6.058,7.362-9.006,11.004-10.404c-4.905-2.288-8.542-6.724-11.01-12.256
			c-7.616,0.16-15.238,0.427-22.77,0.358c-16.559-0.15-33.116-0.368-49.672-0.515c-33.134-0.29-66.288-0.279-99.396,1.206
			c-18.583,0.838-37.153,2.127-55.652,4.093c-1.419-0.16-2.966-0.046-4.634,0.464c-16.09,4.913-29.744,15.958-36.727,31.427
			c-0.645,1.428-1.061,2.91-1.244,4.388c-0.731,1.427-1.196,3.093-1.231,5.042c-1.056,53.786-3.291,107.512,0,161.277
			c0.287,4.626,2.808,7.759,6.058,9.425c1.663,1.584,3.94,2.63,6.911,2.63c21.287,0,42.566-0.092,63.828-1.076
			c0.046,7.14,0.079,13.767,0.089,19.479c0.005,1.991,0.457,3.672,1.186,5.119c1.277,3.65,4.431,6.565,9.463,6.57
			c60.179,0.071,120.351,1.239,180.527,1.311c9.414,0.01,12.238-10.146,8.521-16.315c-0.021-2.377-0.051-4.9-0.086-7.516
			c17.229-0.878,34.479-1.021,51.744-1.021c2.722,0,4.87-0.884,6.5-2.244c6.18,0.924,13.147-2.646,13.132-10.725
			c-0.071-35.222-1.478-70.325-2.574-105.521C346.76,303.619,346.628,294.986,346.358,286.354z"
        />
        <path
          d="M287.952,146.964c1.03,0.521,2.229,0.838,3.646,0.838c0.381,0,0.782-0.028,1.198-0.074
			c20.927-2.506,149.801-3.801,170.834-5.04c12.812-0.754,8.475-16.676,8.562-24.616c0.102-8.736,4.895-24.028-9.882-24.028l0,0
			c-21.424,0-150.658,0.094-172.088,1.259c-11.857,0.645-9.039,13.188-8.282,21.36C282.818,126.106,277.156,141.502,287.952,146.964
			z M453.951,112.951c0,0-2.225,6.246,0.381,11.408c-14.849,0.906-137.532,1.944-152.319,3.479
			c0.152-8.877-2.133-14.059-2.133-14.059C315.281,113.16,438.539,112.982,453.951,112.951z"
        />
        <path
          d="M464.665,160.545c-21.398-1.166-150.658-1.257-172.087-1.257c-15.249,0-16.646,33.72-7.525,44.973
			c1.716,2.115,3.768,3.529,6.205,3.672c3.869,0.229,11.415,0.457,21.241,0.695c43.584,1.062,132.515,2.298,149.592,4.342
			c0.411,0.054,0.812,0.074,1.198,0.074c1.412,0,2.61-0.317,3.642-0.838c4.352-2.199,5.748-5.215,5.997-8.668
			c0.324-4.601-1.401-9.978-0.904-15.213c0.62-6.515,4.864-16.704,0.595-22.668C471.236,162.901,468.596,160.758,464.665,160.545z
			 M452.874,193.087c-14.792-1.536-137.471-2.574-152.323-3.479c2.609-5.159,0.381-11.41,0.381-11.41
			c15.411,0.03,138.669,0.208,154.07,0.828C455.007,179.026,452.717,184.206,452.874,193.087z"
        />
        <path
          d="M469.043,227.374c-1.523-1.701-3.763-2.838-6.733-2.838l0,0c-14.808,0-81.07,0.045-127.691,0.457
			c-20.854,0.183-37.79,0.441-44.412,0.802c-1.346,0.071-2.508,0.557-3.6,1.201c-11.918,7.066-8.902,45.278,1.341,50.457
			c1.03,0.523,2.229,0.838,3.646,0.838c0.381,0,0.782-0.025,1.198-0.071c4.937-0.594,15.925-1.117,30.042-1.584
			c7.032-0.233,14.832-0.462,23.089-0.67c45.438-1.158,104.104-1.98,117.702-2.783c13.808-0.822,8.506-25.958,10.304-35.434
			C474.847,232.944,472.404,229.283,469.043,227.374z M344.485,256.953c-8.46,0.172-16.245,0.345-22.846,0.527
			c-9.603,0.265-16.723,0.549-19.627,0.849c0.152-8.877-2.133-14.062-2.133-14.062c2.93-0.121,9.791-0.218,19.053-0.305
			c6.738-0.061,14.771-0.121,23.501-0.172c42.289-0.244,101.174-0.325,111.518-0.351c0,0-2.225,6.246,0.381,11.41
			C444.415,255.46,386.343,256.125,344.485,256.953z"
        />
      </g>
    </g>
  </svg>

  <svg
    v-else-if="name === 'factory'"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="451.921px"
    height="451.922px"
    viewBox="0 0 451.921 451.922"
    style="enable-background: new 0 0 451.921 451.922"
    xml:space="preserve"
  >
    <g>
      <g>
        <path
          d="M451.874,137.746c-0.005-1.186-0.259-2.232-0.599-3.209c-1.27-6.561-8.917-12.167-16.986-7.502
			c-39.1,22.594-75.448,48.604-113.619,72.351c0.939-23.389,0.223-46.769-1.193-70.183c2.66-8.242-10.451-17.288-19.997-10.077
			c-37.303,28.183-77.886,52.455-117.312,78.15c-1.222-27.061-2.808-54.106-2.976-81.197c-0.005-1.16-0.239-2.184-0.566-3.146
			c-1.559-7.488-12.126-13.198-19.385-5.944c-12.444,12.438-25.885,23.811-39.872,34.602c1.439-38.252,2.724-76.497,2.828-114.777
			c0-1.046-0.16-1.98-0.388-2.864c0.269-5.393-3.047-11.004-10.011-11.004H58.072c-1.064,0-2.011,0.173-2.912,0.411
			c-5.464-0.371-11.131,2.933-10.956,9.988c1.425,58.016-1.704,115.842-6.812,173.619c-10.222,6.426-20.459,12.842-30.625,19.326
			c-1.647,1.057-2.823,2.308-3.656,3.651c-1.351,1.579-2.168,3.639-2.138,6.192C1.775,281.031,0.109,367.103,0,421.996
			c0,1.467,0.317,2.741,0.807,3.884c1.092,4.21,4.695,7.938,10.877,8.247c141.764,7.043,283.702,4.342,425.58,4.342
			c9.069,0,12.645-7.516,10.796-13.518c0.752-9.141,0.427-18.108-1.046-27.157C446.765,321.482,452.499,214.067,451.874,137.746z
			 M101.336,33.749c-0.058,8.668-0.193,17.336-0.343,25.999H65.25c0.051-8.663,0.046-17.331-0.084-25.999H101.336z M64.953,80.547
			h35.571c-0.645,25.598-1.554,51.186-2.542,76.782c-12.588,8.861-25.552,17.331-38.61,25.692
			C62.19,148.895,64.204,114.742,64.953,80.547z M423.635,404.67c0.01,1.955,0.563,3.585,1.422,4.971
			c0.142,2.687,0.173,5.367,0.081,8.049c-133.932,0.132-267.894,2.275-401.696-3.869c0.229-50.679,1.549-132.556,0.935-183.244
			c45.374-28.741,92.094-56.193,131.941-90.825c0.843,26.781,2.544,53.535,3.402,80.318c0.398,12.477,20.741,13.34,23.133,2.516
			c37.912-25.192,77.18-48.729,114.193-74.94c1.031,24.148,1.102,48.271-0.99,72.424c-0.65,7.596,6.591,10.836,13.192,9.8
			c1.727-0.116,3.534-0.604,5.373-1.69c38.958-22.976,75.377-49.117,113.853-72.687C428.195,228.18,423.036,331.974,423.635,404.67z
			"
        />
        <path
          d="M369.098,263.405h-34.084c-5.723,0-9.262,3.001-10.633,6.724c-0.863,1.462-1.32,3.234-1.057,5.408
			c1.864,15.33,1.768,51.394,0,66.729c-0.746,6.52,4.464,9.8,10.166,9.927c1.057,0.279,2.194,0.478,3.474,0.478h33.104
			c6.921,0,10.623-4.388,11.191-9.13c0.29-0.924,0.498-1.899,0.498-3.006v-64.998c0-2.723-0.99-4.865-2.534-6.485
			C377.598,265.857,374.247,263.405,369.098,263.405z M358.383,331.872h-10.775c0.584-8.958,0.579-38.705-0.076-47.667h10.852
			V331.872z"
        />
        <path
          d="M269.762,263.405h-34.083c-5.718,0-9.257,3.001-10.633,6.724c-0.863,1.462-1.315,3.234-1.051,5.408
			c1.861,15.33,1.767,51.394,0,66.729c-0.754,6.52,4.461,9.8,10.161,9.927c1.062,0.279,2.188,0.478,3.474,0.478h33.108
			c6.916,0,10.623-4.388,11.191-9.13c0.284-0.924,0.487-1.899,0.487-3.006v-64.998c0-2.723-0.99-4.865-2.528-6.485
			C278.263,265.857,274.917,263.405,269.762,263.405z M259.053,331.872h-10.775c0.584-8.958,0.573-38.705-0.076-47.667h10.852
			V331.872z"
        />
        <path
          d="M170.432,263.405h-34.086c-5.726,0-9.262,3.001-10.638,6.724c-0.863,1.462-1.315,3.234-1.051,5.408
			c1.861,15.33,1.767,51.394,0,66.729c-0.754,6.52,4.461,9.8,10.161,9.927c1.066,0.279,2.193,0.478,3.479,0.478h33.113
			c6.919,0,10.618-4.388,11.189-9.13c0.292-0.924,0.492-1.899,0.492-3.006v-64.998c0-2.723-0.993-4.865-2.526-6.485
			C178.933,265.857,175.583,263.405,170.432,263.405z M159.72,331.872h-10.775c0.584-8.958,0.579-38.705-0.079-47.667h10.85v47.667
			H159.72z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    name: String,
  },
};
</script>
